import React from 'react';
import { Card, Paper } from '@mui/material';
import WarningTriangle from '../../public/assets/img/warning.svg';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { useNavigate } from 'react-router-dom';
import { initializaMerchantState } from '../redux/actions/amazonWebServicesAction';
import { useDispatch, useSelector } from 'react-redux';
import { initialRouteSaga } from '../redux/saga/merchantServiceSelectors';

const WorkInProgress = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const initialRoute = useSelector(initialRouteSaga);

    const logoutHandler = () => {
        dispatch(initializaMerchantState({type: 'RESET_STATE'}))
        navigate('/'+initialRoute);
    }

    return (
		<>  
			<Card variant='outlined' className='work-progress' data-testid='work-id'>
				<PowerSettingsNewIcon className='work-progress__logouticon' onClick={logoutHandler}/>
				<Paper sx={{ mb: 2}} className='work-progress__paper'> 
					<img src={WarningTriangle} className='work-progress__erroricon'/>
					<h4 className='work-progress__pagetitle'>Work In Progress</h4>
				</Paper>
			</Card>
		</>
    )
}

export default WorkInProgress; 
